import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const session_id = sp.get("session_id");
  const [status, setStatus] = useState("polling"); // polling|paid|failed
  const [productId, setProductId] = useState(null);

  useEffect(() => {
    if (!session_id) return;
    let cancelled = false;
    let tries = 0;
    const poll = async () => {
      tries++;
      try {
        const { data } = await api.get(`/payments/status/${session_id}`);
        setProductId(data.product_id);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.payment_status === "failed" || data.payment_status === "expired") { setStatus("failed"); return; }
      } catch (_e) { /* transient */ }
      if (tries < 20 && !cancelled) setTimeout(poll, 2000);
      else if (!cancelled) setStatus("failed");
    };
    poll();
    return () => { cancelled = true; };
  }, [session_id]);

  return (
    <div className="mx-auto max-w-3xl px-6 lg:px-10 py-24 text-center">
      {status === "paid" ? (
        <>
          <CheckCircle2 className="w-14 h-14 text-[#CCFF00] mx-auto" />
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#CCFF00] mt-6">// TRANSACTION COMPLETE</div>
          <h1 className="font-display font-black text-5xl tracking-tighter mt-3">You own it.</h1>
          <p className="mt-4 text-white/70">Your purchase is in your Library. Enjoy.</p>
          <div className="mt-8 flex gap-3 justify-center">
            <Link to="/library" className="bg-[#FF3366] text-white font-mono uppercase tracking-[0.2em] text-xs px-5 py-3">Go to Library →</Link>
            {productId && <Link to={`/p/${productId}`} className="border border-white/20 hover:border-white/50 font-mono uppercase tracking-[0.2em] text-xs px-5 py-3">View product</Link>}
          </div>
        </>
      ) : status === "polling" ? (
        <>
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/60">// Confirming payment…</div>
          <div className="mt-6 h-1 w-40 bg-white/10 mx-auto overflow-hidden">
            <div className="h-full w-1/3 bg-[#FF3366] animate-pulse" />
          </div>
        </>
      ) : (
        <>
          <XCircle className="w-14 h-14 text-[#FF3366] mx-auto" />
          <h1 className="font-display font-black text-4xl tracking-tighter mt-4">Could not confirm payment.</h1>
          <p className="mt-3 text-white/70">If you were charged, please refresh in a moment.</p>
          <button onClick={() => nav("/")} className="mt-6 border border-white/20 font-mono uppercase tracking-[0.2em] text-xs px-5 py-3">Back to store</button>
        </>
      )}
    </div>
  );
}
